// Self-XSS Warning in Console
(function() {
    const titleStyle = 'color: red; font-size: 40px; font-weight: bold; -webkit-text-stroke: 1px black;';
    const bodyStyle = 'color: #111; font-size: 18px; font-weight: bold;';

    console.log('%cHold Up!', titleStyle);
    console.log(
        '%cUsing this console may allow attackers to impersonate you and steal your information using an attack called Self-XSS. Do not enter or paste code that you do not understand.', 
        bodyStyle
    );
})();

// Main application entry for Cosmo Crypt
import { initRouter, ensureTemplateLoaded } from './router.js';
import './sss-service.js';
import './cosmo-search.js';
import './title-manager.js';

// Pre-load the initial template ASAP so it's ready when app-controller's init() fires
const initialPath = window.location.pathname.replace(/^\/|\/$/g, '');
const initialSlug = (initialPath && initialPath !== 'index.html' && initialPath !== 'dist') ? initialPath.split('/')[0] : 'about';

// Start fetching immediately (don't wait for DOMContentLoaded)
const templateReady = ensureTemplateLoaded(initialSlug);

// Store the promise globally so app-controller can await it if needed
window.__cosmoTemplateReady = templateReady;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initRouter();
  });
} else {
  initRouter();
}

